import { Component, Injectable, OnInit} from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Router } from '@angular/router';
import { AppSettings } from '../appSettings';
import { LoginService } from '../services/login.service';
import { CommonService } from '../services/common.service';
declare let swal: any;
declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-mall-login-new',
  templateUrl: './studentloginnew.component.html',
  styleUrls: ['./studentloginnew.component.css'],
})
export class StudentLoginNewComponent implements OnInit {

  model: any = {};
  data:any={};
  entered:any;
  users :any= []; //storing the data from the API
  userRestApiUrl: string = AppSettings.Userlogin; //API common URL

  constructor(private loginService: LoginService,private CommonService: CommonService,private router: Router,private http:Http) {

    document.body.className="login-page";

   }

  ngOnInit() {
     this.entered = 0;

    //  let translate_url="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    //this.loadScript(translate_url);
     
  }

  public loadScript(url) {
    console.log('preparing to load...')
    let node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  

   enterlogin()
  {
    if(this.entered==0)
    {
      this.checklogin();
      this.entered=1;
    }
    if(this.entered==1)
    {
      //this.login();
      this.entered=0;
    }
  }  

  checklogin(){
    //alert(JSON.stringify(this.model));

    let usernme = null;
    let userpass = null;
    usernme = this.model.user_name;
    userpass = this.model.user_password;
   // alert(usernme);
    if((usernme==undefined || usernme==null)&&(userpass==undefined || userpass==null))
    {
      swal('Oops...', 'Enter Valid Lock and Key', 'error');
      
      if(this.entered==0)
      {
        this.entered=1;
      }
      // window.location.reload();
    }
    else 
    {
      if(usernme!=null && userpass!=null){
          swal('Info', 'Coming Soon', 'info');
        
      }
    }

                
  }


  logout() {
        // remove user from local storage to log user out
      	// swal('', 'You have Successfully Logged Out', 'success');        
        localStorage.removeItem('currentUser');
        localStorage.clear();
    }


}
